import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { DataEnrichment } from "../../src/landingPage/views/Usecases/DataEnrichment/DataEnrichment";

const DataEnrichmentPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/contact-data-enrichment"
        title={meta.usecases.dataenrichment.title}
        description={meta.usecases.dataenrichment.description}
      />
      <DataEnrichment />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default DataEnrichmentPage;
